<template>
  <el-card class="box-card full-screen cash-record-statistics">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            :picker-options="pickerOptions0"
            @change="changeDate"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('checkPending')" value="0"></el-option>
            <el-option :label="$t('getApproved')" value="1"></el-option>
            <el-option :label="$t('notApproved')" value="2"></el-option>
            <el-option :label="$t('reversed')" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>

      <el-row class="table-btns" v-if="loginInfo.orgType != 1">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="expenseApply"
          >{{ $t("addExpense") }}</el-button
        >
      </el-row>
    </div>

    <!-- Data Table -->
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="table.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          type="index"
          align="center"
          fixed="left"
          width="50"
        ></el-table-column>
        <el-table-column
          fixed="left"
          prop="applyOrg"
          :label="$t('applyOrg')"
          width="160"
        >
          <template slot-scope="scope">
            {{ scope.row.orgName }} ({{ scope.row.orgInfoCode }})
          </template>
        </el-table-column>
        <el-table-column
          prop="expenseType"
          :label="$t('expenseType')"
          min-width="300"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.expenseType }}
          </template>
        </el-table-column>

        <el-table-column prop="amount" :label="$t('amount')" width="200">
          <template slot-scope="scope">
            <span class="franc">FCFA</span>{{ scope.row.amount.formatMoney(0) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="reason"
          :label="$t('reason')"
          min-width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="status" :label="$t('checkStatus')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-primary">{{
              $t("checkPending")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-success">{{
              $t("getApproved")
            }}</span>
            <span v-if="scope.row.status == 2" class="text-danger">{{
              $t("notApproved")
            }}</span>
            <span v-else-if="scope.row.status == 4" class="text-warning">{{
              $t("reversed")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('creationTime')"
          width="150"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column
          prop="applyUser"
          :label="$t('applyUser')"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.orgLoginName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyUser"
          :label="$t('verifyUser')"
          min-width="120"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyUser">{{ scope.row.verifyUser }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyTime"
          :label="$t('verifyTime')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyTime">{{
              $manba(scope.row.verifyTime).format("ymdhms")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="verifyRemark"
          :label="$t('verifyRemark')"
          min-width="200"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.verifyRemark">{{
              scope.row.verifyRemark
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isAdmin"
          fixed="right"
          :label="$t('extend')"
          width="220"
        >
          <template slot-scope="scope">
            <el-button
              v-if="isAdmin && scope.row.status == 1"
              type="danger"
              size="mini"
              @click="openReverse(scope.row)"
              >{{ $t("reverseExpense") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--End Data Table-->
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="table.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(applyTitle)"
      :visible.sync="isAddApply"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="500"
    >
      <el-form :model="applyForm" :rules="rules" ref="applyForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>

        <el-form-item :label="$t('expenseType')" prop="expenseType">
          <el-select
            size="medium"
            v-model="applyForm.expenseType"
            filterable
            :placeholder="$t('select')"
            style="width:100%;"
          >
            <el-option
              v-for="item in expenseTypeList"
              :key="item.id"
              :label="$t(`${item.name}`)"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('applyAmount')" prop="applyAmount">
          <el-input
            size="medium"
            v-model="applyForm.applyAmount"
            @input="onAmountInput"
          >
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <el-form-item :label="$t('ApplyReason')" prop="reason">
          <el-input
            type="textarea"
            size="medium"
            v-model="applyForm.reason"
          ></el-input>
        </el-form-item>
        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="onSubmitAdd('applyForm')"
            >{{ $t("submit") }}</el-button
          >
        </div>
      </el-form>
    </el-drawer>

    <el-drawer
      :title="$t('reverseExpense')"
      :visible.sync="isReverse"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="reverseForm" :rules="reverseRules" ref="reverseForm">
        <el-divider content-position="left">{{ $t("applyInfo") }}</el-divider>

        <el-form-item :label="$t('expenseType')">
          <el-input size="medium" v-model="reverseForm.expenseType" disabled />
        </el-form-item>
        <el-form-item :label="$t('applyAmount')">
          <el-input size="medium" :value="reverseAmountLabel" disabled />
        </el-form-item>
        <el-form-item :label="$t('ApplyReason')">
          <el-input
            type="textarea"
            size="medium"
            v-model="reverseForm.reason"
            disabled
          />
        </el-form-item>
        <el-form-item :label="$t('orgName')">
          <el-input size="medium" v-model="reverseForm.orgName" disabled />
        </el-form-item>

        <el-alert
          :title="$t('reverseExpenseWarning')"
          type="warning"
          :closable="false"
          show-icon
          style="margin: 12px 0"
        />

        <el-divider content-position="left">{{ $t("checkInfo") }}</el-divider>

        <el-form-item :label="$t('reason')" prop="reverseReason">
          <el-input
            type="textarea"
            :rows="3"
            size="medium"
            v-model="reverseForm.reverseReason"
          />
        </el-form-item>

        <div class="bottom-button">
          <el-button
            size="medium"
            type="danger"
            :loading="isReversing"
            @click="onSubmitReverse('reverseForm')"
            >{{ $t("reverseExpense") }}</el-button
          >
          <el-button size="medium" @click="isReverse = false">{{
            $t("cancel")
          }}</el-button>
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import expense from "@/api/expense";
//import manba from '@/assets/uilt/manbaDate'

export default {
  name: "expenseList",
  data() {
    return {
      //table高度，动态设置
      queryTableHeight: String,
      queryForm: {},
      expenseTypeList: [],
      isReverse: false,
      isReversing: false,
      reverseForm: {},
      isLoading: false,

      table: {},

      pageSize: 20,
      currentPage: 1,

      applyTitle: "addExpense",
      applyForm: {},

      isAddApply: false,

      //禁用今天之后的日期选项
      pickerOptions0: {
        onPick: ({ maxDate, minDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
        disabledDate: time => {
          let today = 3 * 30 * 24 * 3600 * 1000;
          if (this.minDate) {
            return (
              time.getTime() > Date.now() ||
              time > new Date(this.minDate.getTime() + today) ||
              time < new Date(this.minDate.getTime() - today)
            );
          }
          return time.getTime() > Date.now();
        }
      }
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    rules() {
      return {
        expenseType: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        applyAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        reason: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
        //businessCode: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
      };
    },
    isAdmin() {
      return (
        this.loginInfo.orgType == 1 && this.loginInfo.job === "ADMINISTRATEUR"
      );
    },
    reverseAmountLabel() {
      return "FCFA " + Number(this.reverseForm.amount || 0).formatMoney(0);
    },
    reverseRules() {
      return {
        reverseReason: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    }
  },

  watch: {
    "queryForm.date"(newVal) {
      if (newVal && newVal.length > 0) {
        this.queryForm.startTime = this.queryForm.date[0];
        this.queryForm.endTime = this.queryForm.date[1];
      } else {
        this.queryForm.startTime = undefined;
        this.queryForm.endTime = undefined;
      }
    }
  },

  methods: {
    getList() {
      let _this = this;
      _this.isLoading = true;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startTime = _this.$manba(params.date[0]).format("ymd");
        params.endTime = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startTime = undefined;
        params.endTime = undefined;
      }
      delete params.date;

      expense.getExpensePage({
        param: {
          current: _this.table.currentPage,
          size: _this.table.pageSize,
          ...params
        },
        success: res => {
          _this.table = res.data || {};
          _this.isLoading = false;
        }
      });
    },
    changeDate(e) {
      if (e === null) {
        this.minDate = "";
        this.maxDate = "";
        this.pickerBeginDateBefore = {
          disabledDate: time => {
            let three = 3 * 30 * 24 * 3600 * 1000;
            if (this.minDate) {
              return (
                time.getTime() > Date.now() ||
                time > new Date(this.minDate.getTime() + three) ||
                time < new Date(this.minDate.getTime() - three)
              );
            }
            return time.getTime() > Date.now();
          }
        };
      }
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    expenseApply() {
      this.isAddApply = true;
    },
    onAmountInput(val) {
      const raw = String(val || "").replace(/\D/g, "");
      this.applyForm.applyAmount = raw
        ? raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        : "";
    },
    /**提交充值申请 */
    onSubmitAdd(refName) {
      let _this = this;

      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        _this.isLoading = true;

        const amount =
          parseFloat(
            String(_this.applyForm.applyAmount || "0").replace(/\s/g, "")
          ) || 0;

        if (amount <= 0) {
          _this.isLoading = false;
          _this.$message.warning(_this.$t("requiredFields"));
          return;
        }

        expense.addExpense({
          param: _this[refName],
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.isAddApply = false;
              _this.getList();
            } else _this.$message.warning(_this.$t(res.msg));
          }
        });
      });
    },
    getExpenseList() {
      //console.log("Boubacar");
      let _this = this;
      expense.getAllExpenseType({
        success: res => {
          if (res.code == 200) {
            _this.expenseTypeList = res.data;
          }
        }
      });
    },
    openReverse(row) {
      this.reverseForm = {
        id: row.id,
        expenseType: row.expenseType,
        amount: row.amount,
        reason: row.reason,
        orgName: row.orgName,
        reverseReason: ""
      };
      this.isReverse = true;
    },
    onSubmitReverse(refName) {
      this.$refs[refName].validate(valid => {
        if (!valid) return false;

        this.$confirm(this.$t("reverseExpenseConfirm"), this.$t("confirm"), {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          type: "warning"
        })
          .then(() => {
            this.isReversing = true;
            expense.reverseExpense({
              param: {
                id: this.reverseForm.id,
                reason: this.reverseForm.reverseReason.trim()
              },
              success: res => {
                this.isReversing = false;
                if (res.code == 200) {
                  this.$message.success(this.$t("operateSuccessfully"));
                  this.isReverse = false;
                  this.getList();
                } else {
                  this.$message.warning(this.$t(res.msg));
                }
              },
              failing: () => {
                this.isReversing = false;
                this.$message.error(this.$t("networkError"));
              }
            });
          })
          .catch(() => {});
      });
    }
  },
  mounted() {
    //console.log("Betto Component mounted");
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";

    this.getList();
    this.getExpenseList();
  }
};
</script>

<style lang="less" scoped></style>
